import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';

@Component({
  standalone: false,
  selector: 'app-treatment-xray-data-dialog',
  templateUrl: './treatment-xray-data-dialog.component.html',
  styleUrls: ['./treatment-xray-data-dialog.component.scss']
})
export class TreatmentXrayDataDialogComponent implements OnInit {
  isLoading = true;

  date: string;
  numberOfXrays: string;
  voltageInKv: string;
  amperageInMa: string;
  exposureTimeInSeconds: string;

  constructor(private dialogRef: MatDialogRef<TreatmentXrayDataDialogComponent>) { }

  ngOnInit(): void {
    this.isLoading = false;
  }

  onOkClick() {
    let note = '';

    note += 'Date: ' + this.date + '\r\n';
    note += 'Number Of XRays: ' + this.numberOfXrays + '\r\n';
    note += 'Voltage in kV: ' + this.voltageInKv + '\r\n';
    note += 'Amperage in mA: ' + this.amperageInMa + '\r\n';
    note += 'Exposure time in seconds: ' + this.exposureTimeInSeconds + '\r\n';

    this.dialogRef.close(note);
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  isAllFilled() {
    if (this.date && this.numberOfXrays && this.voltageInKv && this.amperageInMa && this.exposureTimeInSeconds) {
      return true;
    }

    return false;
  }

  onStartDateFocus(event: FocusEvent) {

  }

  onStartDateChange(event: MatDatepickerInputEvent<any, any>) {

  }
}
